import { brandForDomain } from '../utils/platform/brand';
import { extendTheme } from 'native-base';

const themeBrand = brandForDomain();

const gray100 = 'rgb(246,246,246)';

export const trueGreenBoxBG = '#00000073';
export const trueGreenLightgreen = '#03F17E';
export const trueGreenDarkgreen = '#03F17E';

export const theme = extendTheme({
  ...(themeBrand === 'portal' && {
    fonts: {
      heading: 'DM Serif Display',
      body: 'DM Sans',
    },
    colors: {
      footerText: 'gray',
      footerLine: 'rgb(244, 244, 245)',
      headerBackground: '#f4f6fc',
      headerTitle: '#0c0890',
      openNow: '#16a34a',
      headerBackArrow: 'black',
      secureEncrypted: 'rgb(113, 113, 122)',
      servicesBackground: '#f4f6fc',
      title: '#0c0890',
      formHeader: 'black',
      formLabel: 'black',
      formHelp: 'rgb(113, 113, 122)',
      formOptionBGSelected: 'rgb(139, 215, 246)',
      formOptionBG: 'white',
      formOptionBorderSelected: 'rgb(139, 215, 246)',
      formOptionBorder: 'rgb(228, 228, 231)',
      formOptionText: 'black',
      formOptionTextSelected: 'black',
      loginBackground: 'rgb(250, 250, 250)',
      loginLabel: 'black',
      callOutBoxBg: gray100,
      callOutBoxText: 'black',
      headerAccount: 'rgb(82, 82, 91)',
      serviceBoxBackground: 'white',
      serviceBoxTitle: 'rgb(32, 51, 201)',
      serviceBoxText: 'black',
      serviceBoxPrice: 'rgb(82, 82, 91)',
      paymentBoxBackground: gray100,
      paymentBoxTitle: 'black',
      progressBarBackground: 'rgb(239, 246, 255)',
      progressBarFill: 'rgb(96, 165, 250)',
      progressBarText: 'black',
      requestHeaderBorder: 'rgb(212, 212, 216)',
      doctorAssignedBackground: gray100,
      doctorAssignedText: 'black',
      inProgressLabelBg: 'white',
      messagingBubble: '#0c79ec',
      messagingBubbleAlt: 'rgb(95 95 95)',
      messagingBubbleHeader: 'black',
      messagingBubbleText: 'white',
      messagingBubbleFooter: 'rgb(113, 113, 122)',
      loaderColor: 'black',
      paymentPointHighlights: '#0c0890',
      faqs: 'black',
      doctorOnlineColor: 'green',
      faqTitle: 'white',
    },
    components: {
      Button: {
        defaultProps: {
          variant: 'solid',
        },
        sizes: {
          md: {
            px: 10,
            py: 3,
          },
          sm: {
            px: 3,
          },
        },
        variants: {
          outline: {
            _text: {
              color: 'black',
              fontWeight: 600,
            },
          },
          form: {
            borderRadius: 'sm',
            size: 'lg',
            bg: 'rgb(32, 51, 201)',
            _text: {
              color: 'white',
              fontWeight: 600,
            },
          },
          solid: {
            borderRadius: 'sm',
            size: 'lg',
            bg: 'rgb(32, 51, 201)',
            _text: {
              color: 'white',
              fontWeight: 600,
            },
          },
          secondary: {
            borderRadius: 'sm',
            bg: 'rgb(139, 215, 246)',
            _text: {
              color: 'rgb(12, 8, 144)',
              fontWeight: 600,
            },
          },
        },
      },
      Text: {
        baseStyle: {
          color: 'black',
        },
      },
    },
  }),

  ...(themeBrand === 'leafdoctors' && {
    fonts: {
      heading: 'Dinamit Headings',
      body: 'Bastardo Body Copy',
    },
    typography: {
      '2xs': 10,
      xs: 12,
      sm: 14,
      md: 16,
      lg: 18,
      xl: 20,
      '2xl': 24,
      '3xl': 30,
      '4xl': 36,
      '5xl': 48,
      '6xl': 60,
      '7xl': 72,
      '8xl': 96,
      '9xl': 128,
    },
    colors: {
      footerText: 'gray',
      footerLine: 'rgb(244, 244, 245)',
      headerBackground: '#f4f6fc',
      headerTitle: '#0c0890',
      openNow: '#16a34a',
      headerBackArrow: 'black',
      secureEncrypted: 'rgb(113, 113, 122)',
      servicesBackground: '#f4f6fc',
      title: '#0c0890',
      formHeader: 'black',
      formLabel: 'black',
      formHelp: 'black',
      formOptionBGSelected: '#123b36',
      formOptionBG: 'white',
      formOptionBorderSelected: '#123b36',
      formOptionBorder: 'rgb(228, 228, 231)',
      formOptionText: 'black',
      formOptionTextSelected: 'white',
      loginBackground: 'rgb(250, 250, 250)',
      loginLabel: 'black',
      callOutBoxBg: gray100,
      callOutBoxText: 'black',
      headerAccount: 'rgb(82, 82, 91)',
      serviceBoxBackground: 'white',
      serviceBoxTitle: '#66462C',
      serviceBoxText: 'black',
      serviceBoxPrice: 'rgb(82, 82, 91)',
      paymentBoxBackground: '#f7f5ed',
      paymentBoxTitle: 'black',
      progressBarBackground: 'rgb(239, 246, 255)',
      progressBarFill: 'rgb(96, 165, 250)',
      progressBarText: 'black',
      requestHeaderBorder: 'rgb(212, 212, 216)',
      doctorAssignedBackground: gray100,
      doctorAssignedText: 'black',
      inProgressLabelBg: 'white',
      messagingBubble: '#0c79ec',
      messagingBubbleAlt: 'gray',
      messagingBubbleHeader: 'black',
      messagingBubbleText: 'white',
      messagingBubbleFooter: 'rgb(113, 113, 122)',
      loaderColor: '#333333',
      paymentPointHighlights: '#66462C',
      faqs: 'black',
      doctorOnlineColor: 'green',
      faqTitle: 'white',
    },
    components: {
      Button: {
        defaultProps: {
          variant: 'solid',
        },
        sizes: {
          md: {
            px: 10,
            py: 3,
          },
          sm: {
            px: 3,
          },
        },
        variants: {
          outline: {
            borderRadius: '3xl',
            size: 'lg',
            bg: null,
            borderColor: 'black',
            _text: {
              fontFamily: 'Tiemposfine Subheadings',
              color: 'black',
              fontSize: '16px',
            },
          },
          form: {
            borderRadius: '3xl',
            size: 'lg',
            bg: 'black',
            _text: {
              fontFamily: 'Tiemposfine Subheadings',
              color: 'white',
              fontSize: '16px',
            },
          },
          solid: {
            borderRadius: '3xl',
            size: 'lg',
            bg: 'black',
            _text: {
              fontFamily: 'Tiemposfine Subheadings',
              color: 'white',
              fontSize: '16px',
            },
          },
          secondary: {
            borderRadius: '3xl',
            size: 'lg',
            bg: 'black',
            _text: {
              fontFamily: 'Tiemposfine Subheadings',
              color: 'white',
              fontSize: '16px',
            },
          },
        },
      },

      Text: {
        baseStyle: {
          color: 'black',
          fontSize: 'md',
        },
      },
    },
  }),
});
